import React from 'react';

/**
 * Isolates component failures so the app shell stays usable.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[Galaxia Metaverse Bridge]', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    const { children, fallbackTitle = 'This section failed to load' } = this.props;

    if (error) {
      return (
        <div className="galaxia-card p-6" role="alert">
          <h3 className="text-lg font-semibold mb-2" style={{ color: 'var(--galaxia-warning)' }}>
            {fallbackTitle}
          </h3>
          <p className="text-sm mb-4" style={{ color: 'var(--galaxia-muted)' }}>
            The rest of Galaxia Metaverse Bridge remains available. Refresh the page or continue using other sections.
          </p>
          <button
            type="button"
            className="galaxia-btn-secondary px-4 py-2 text-sm"
            onClick={() => this.setState({ error: null })}
          >
            Try again
          </button>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
